import Component from './MapLayerList';
export default Component;

export const componentName = 'MapLayerList';
